export default "__VITE_PUBLIC_ASSET__9e4f641b__"